module.exports = __webpack_public_path__ + "media/recipes/122-925995ee.png";